import { connect } from 'react-redux';
import CurrencyCalculator from '../../components/instrument/CurrencyCalculator';
import { closeModal, openModal } from '../../redux/app';
import { requestTickerData, fetchCryptocurrency } from '../../actions/ticker';
import { getDeviceBreakpoint } from '../../service/device';

function mapStateToProps({ app, currencies, device: { windowWidth } }, { symbol }) {
    const { modalOpen } = app;

    return {
        symbol: !symbol ? 'X:SUSDSEK.IDCFX' : symbol,
        ...currencies.calculator,
        modalOpen: modalOpen === 'currenciesModal',
        breakpoint: getDeviceBreakpoint(windowWidth),
    };
}

const mapDispatchToProps = {
    requestTickerData,
    fetchCryptocurrency,
    closeModal,
    openModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyCalculator);



/** WEBPACK FOOTER **
 ** /src/shared/containers/instrument/CurrencyCalculator.js
 **/